import ApiService from "../../services/ApiService";
import translate from "../../services/Translate";

export const openRecordLink = (recordLink: any, language: string) => {
  if (window.confirm(translate(language, "PAGES.USER.MEETING.BUTTON.POPUP_MESSAGE"))) {
    navigator.clipboard.writeText(recordLink.password);
    window.open(recordLink.share_url, "_blank");
  }
};

export const getFontClass = (isPast: boolean, attended: string | null): string => {
  if (isPast) {
    if (attended && ["attended", "justified_absence", "forgotten_signature"].includes(attended)) {
      return "green-font";
    }
    return "dark-red-font";
  }
  return "yellow-font";
};

export const renderAttendance = (isPast: boolean, attended: boolean | string, language: string) => {
  if (!isPast) return null;
  if (typeof attended === "boolean") {
    return attended
      ? translate(language, "PAGES.USER.MEETING.ATTENDANCE.PRESENT")
      : translate(language, "PAGES.USER.MEETING.ATTENDANCE.ABSENT");
  } else {
    return translate(language, `PAGES.USER.MEETING.ATTENDANCE.${attended.toUpperCase().replace(" ", "_")}`);
  }
};

export const getAttendanceIconClass = (attended: string | null) => {
  switch (attended) {
    case "attended":
    case "forgotten_signature":
      return "dst-icon-user-plus-02";
    case "justified_absence":
      return "dst-icon-user-right-02";
    case "absent":
      return "dst-icon-user-x-02";
    default:
      return "";
  }
};

export const updateAbsenceProofStatus = (
  meetingId: string,
  userId: number,
  status: "validated" | "declined",
  language: string,
  onSuccess: Function,
  setLoading: Function
) => {
  setLoading(true);

  ApiService.put(`meetings/${meetingId}/absence-proofs/${userId}/status`, { status })
    .then(() => {
      alert(translate(language, "PAGES.MEETINGS_JUSTIFY_ABSENCE.ALERTS.SUCCESS.UPDATED_STATUS"));
      onSuccess();
    })
    .catch((err) => {
      console.error("Error updating absence proof status:", err);
      alert(translate(language, "PAGES.MEETINGS_JUSTIFY_ABSENCE.ALERTS.ERROR.UPDATE_STATUS"));
    })
    .finally(() => {
      setLoading(false);
    });
};
